const styles = theme => ({
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    padding: '10px 16px',
    [theme.breakpoints.up('sm')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      fontWeight: '600',
    },
  },
  itemTitle: {
    fontSize: '1em',
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
  },
  actionBtn: {
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    padding: '5px',
    borderRadius: '0px',
    '&:last-child': {
      marginLeft: '16px',
    },
    '&:hover': {
      border: 'none !important',
      background: `${theme.palette.primary.adgmHover} !important`,
      '& svg path': {
        fill: 'white',
      },
    },
  },
  itemWrapper: {
    marginBottom: '0px',
  },
  itemContentWrapper: {
    padding: '16px 0px',
    color: theme.palette.secondary.dim,
    lineHeight: 1.5,
    fontSize: '16px',
  },
  itemENContent: {
    borderRight: `1px solid ${theme.palette.primary.borderColor}`,
    paddingRight: '16px',
  },
  itemArContent: {
    fontFamily: 'madani, sans-serif',
    direction: 'rtl',
    paddingLeft: '16px',
  },
  readMoreLink: {
    textTransform: 'lowercase',
    '& > span': {
      display: 'inline-block',
      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
    background: 'transparent !important',
    color: `${theme.palette.primary.main}`,
  },
  toggleIcon: {
    marginLeft: '5px',
  },
  '@media (min-width: 768px)': {
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
  },
  '@media (max-width: 767px)': {
    titleHead: {},
  },
  [theme.breakpoints.down('sm')]: {
    titleHead: {
      flexWrap: 'wrap',
      padding: '16px 20px',
    },
  },
});
export default styles;
